import { observer } from 'owa-mobx-react';
import React from 'react';
import ShimmerRowThreeCol from './ShimmerRowThreeColV9';
import ShimmerRowSLV from './ShimmerRowSLVV9';
import { getMinimumRowHeight, isSingleLineListView } from 'owa-mail-layout';
import {
    getActiveMailListLoadId,
    getMailListLoadDatapointContext,
    isMailListLoadGenerationEnabled,
    subscribeToMailListLoadChanges,
} from 'owa-mail-logging/lib/utils/mailListLoad/mailListLoadDatapointGetterAndSetter';
import { getDensityModeString } from 'owa-fabric-theme';

import classNames from 'owa-classnames';
import { hideScrollContainers, mailListShimmerStateContainer } from './MailListShimmerState.scss';

export interface MailListShimmerStateProps {
    heightOfView: number; // The height of the list view
    tableViewId: string;
}

const MailListShimmerState: React.FunctionComponent<MailListShimmerStateProps> = observer(
    function MailListShimmerState(props: MailListShimmerStateProps) {
        const shimmerRows = [];
        const isSingleLineViewOff = !isSingleLineListView();
        const densityModeString = getDensityModeString();

        // Calculate height of shimmer rows to add just enough rows to fill list view
        let totalHeightOfView = 0;
        const shimmerRowHeight = getMinimumRowHeight(false /* isCondensedRow */);
        const hasMounted = React.useRef<boolean>(false);
        const isMailListLoadGenerationFlightEnabled = isMailListLoadGenerationEnabled();
        const mailListLoadId = React.useSyncExternalStore(
            subscribeToMailListLoadChanges,
            () =>
                isMailListLoadGenerationFlightEnabled
                    ? getActiveMailListLoadId(props.tableViewId)
                    : undefined,
            () => undefined
        );

        React.useEffect(() => {
            if (!isMailListLoadGenerationFlightEnabled && hasMounted.current) {
                return;
            }
            hasMounted.current = true;

            const context = getMailListLoadDatapointContext();
            const mllDp =
                !isMailListLoadGenerationFlightEnabled ||
                (context?.tableViewId === props.tableViewId && context.loadId === mailListLoadId)
                    ? context?.datapoint
                    : undefined;
            if (mllDp) {
                mllDp.addToCustomWaterfall(
                    1,
                    'lc_rendered', // loading component rendered
                    true /*discardIfDefined*/
                );
                mllDp.addCustomData({ lc: 'Shimmer' }); // loading component
            }
        }, [props.tableViewId, isMailListLoadGenerationFlightEnabled, mailListLoadId]);

        // Account for padding on the first message
        // Should correspond with the paddingFirstMessage/paddingMessage classes in
        // ShimmerRowSLVV9.scss and ShimmerRowThreeColV9.scss
        if (isSingleLineViewOff) {
            densityModeString === 'full' ? (totalHeightOfView += 6) : (totalHeightOfView += 10);
        } else {
            densityModeString === 'full' ? (totalHeightOfView += 4) : (totalHeightOfView += 6);
        }

        let i = 0;
        while (totalHeightOfView < props.heightOfView) {
            shimmerRows.push(
                isSingleLineViewOff ? (
                    <ShimmerRowThreeCol key={i} isFirstMessage={i === 0} />
                ) : (
                    <ShimmerRowSLV key={i} isFirstMessage={i === 0} />
                )
            );
            ++i;
            totalHeightOfView += shimmerRowHeight;
        }

        return (
            <div className={classNames(hideScrollContainers, mailListShimmerStateContainer)}>
                {shimmerRows}
            </div>
        );
    },
    'MailListShimmerState'
);
export default MailListShimmerState;
